import { FeedPanel } from "@/features/landing/components/FeedPanel.tsx";
import { GanttPanel } from "@/features/landing/components/GanttPanel.tsx";
import { HourSection } from "@/features/landing/components/HourSection.tsx";
import { PontoPanel } from "@/features/landing/components/PontoPanel.tsx";
import { RdoPreview } from "@/features/landing/components/RdoPreview.tsx";
import { SCurvePanel } from "@/features/landing/components/SCurvePanel.tsx";

// The features, told as one workday: each section is stamped with the hour it
// happens, from the first punch at 07:12 to the Relatório de Obra at 17:48.
export function Workday() {
	return (
		<div data-slot="workday" id="dia">
			<HourSection
				id="ponto"
				time="07:12"
				label="Ponto"
				title="A equipe bate o ponto na própria obra."
				text="Cada pessoa registra entrada, intervalos e saída pelo celular. A jornada da obra fica configurada uma vez, e a folha de horas se monta sozinha."
				facts={[
					"Jornada e tolerâncias definidas por obra",
					"Lembrete para quem esqueceu de bater o ponto",
					"Folha de horas por período, pronta para o fechamento",
				]}
			>
				<PontoPanel />
			</HourSection>

			<HourSection
				id="feed"
				time="07:40"
				label="Feed da obra"
				title="Quem não está no canteiro vê o que acontece nele."
				text="O relato vai para o feed da obra com fotos, vídeos, etapa e o clima daquele momento. Engenheiro, diretoria e cliente acompanham pelo celular e reagem."
				facts={[
					"Fotos e vídeos direto da câmera do celular",
					"Clima registrado automaticamente pelo endereço da obra",
					"Reações e notificações no sino para quem precisa saber",
					"Cada pessoa vê só as obras para as quais foi convidada",
				]}
				flip
			>
				<FeedPanel />
			</HourSection>

			<HourSection
				id="medicao"
				time="10:15"
				label="Medição"
				title="68 m³ de 90 m³. O avanço da obra sai da medição."
				text="Registre a medição da etapa e o avanço realizado é recalculado. A curva S compara com o planejado e mostra o desvio no dia em que ele aparece, não no fim do mês."
				facts={[
					"Etapas organizadas em níveis, com modelos reaproveitáveis",
					"Painel com obras atrasadas e desvio de cada canteiro",
				]}
			>
				<SCurvePanel />
			</HourSection>

			<HourSection
				id="cronograma"
				time="14:00"
				label="Cronograma"
				title="Previsto × realizado. Sem planilha."
				text="Um Gantt só, com a barra do que foi planejado e a do que aconteceu de verdade. O atraso até hoje aparece destacado, e a nota explica o porquê."
				facts={[
					"Datas reais preenchidas pela obra ou ajustadas à mão",
					"Notas com gravidade presas à etapa e ao dia",
					"Tela cheia para a reunião de obra",
				]}
				flip
			>
				<GanttPanel />
			</HourSection>

			<HourSection
				id="rdo"
				time="17:48"
				label="Relatório de Obra"
				title="O relato do dia vira Relatório de Obra em PDF."
				text="O Relatório de Obra já nasce preenchido com as atividades, fotos, clima, horário do primeiro e do último registro e situação de cada etapa. O engenheiro revisa, finaliza, e o PDF fica guardado na obra."
				facts={[
					"Logo da construtora e responsável técnico com CREA",
					"Numeração sequencial que nunca se repete",
					"Revisões guardam a versão anterior, sem apagar nada",
					"A curva de avanço sai na data do relatório",
				]}
			>
				<RdoPreview />
			</HourSection>
		</div>
	);
}
